import { pathEvents } from "./path_events";

const dataKeyTranspose = {
  sh: "spaceHash",
  n: "spaceName",
  v: "venueName",
  vh: "venueHash",
  viewerID: "viewer",
  action: "action",
};

export const eventData = (event, data = {}) => {
  if (window.vs && window.vs.space) data = { ...data, ...window.vs.space };
  if (window.vs && window.vs.venue) data = { ...data, ...window.vs.venue };
  const keys = Object.keys(data);
  const op = {};
  keys.forEach((key) => {
    let exclude = !dataKeyTranspose[key];
    // exclude space data in VDP tracking
    if (!exclude && event === pathEvents.vdp_index) {
      if (dataKeyTranspose[key].match(/^space/)) exclude = true;
    }

    if (!exclude) op[dataKeyTranspose[key]] = data[key];
  });
  op.url = window.location.pathname;
  return op;
};
